module.exports = __webpack_public_path__ + "img/selectedtick.f7c922c8.svg";